import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
	Button,
	Grid,
	Row,
	Col,
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AvatarUpload.css';
import { graphql, gql, compose } from 'react-apollo';
import {
	doUploadProfilePicture,
} from '../../../actions/manageUserProfilePicture';
// Redux
import { connect } from 'react-redux';

// Component
import Avatar from '../../Avatar';
import DropZone from './DropZone';
import Loader from '../../Loader';

// Locale
import messages from '../../../locale/messages';

import defaultPic from './avatar_default.svg';

class AvatarUpload extends Component {
	static propTypes = {
		profilePhotoLoading: PropTypes.bool,
		guestPicture: PropTypes.string,
		guestDisplayName: PropTypes.string.isRequired,
		nextPage: PropTypes.any.isRequired,
		emailVerified: PropTypes.bool.isRequired,
		formatMessage: PropTypes.any,
	};

	static defaultProps = {
		profilePictureData: {
			loading: true
		},
		profilePhotoLoading: false
	};

	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick() {
		const { nextPage, emailVerified, payinData } = this.props;
		// if (!emailVerified) {
		// 	nextPage('verification');
		// } else if(payinData.length === 0) {
		// 	nextPage('payin');
		// }
		// else {
		// }

		nextPage('payment');

	}

	
	handleSkip = () => {
		const { nextPage, doUploadProfilePicture} = this.props;
		console.log("upload",defaultPic)

		
		//   doUploadProfilePicture("defaultPic.png", null);
			nextPage('payment');
	
			
		

	}

	render() {
		const { profilePictureData: { loading, userAccount }, guestPicture, guestDisplayName, profilePhotoLoading } = this.props;
		const { formatMessage } = this.props.intl;
		return (
			<Grid>
				<Row>
					<div className={s.pageContainer}>
						<div className={s.activationStepPanel}>
							<div className={s.panelBody}>
								<h3 className={s.space1}>
									<span><FormattedMessage {...messages.addProfilePhoto} /></span>
								</h3>
								<div className={cx(s.textLead, s.space4)}>
									<div>
										<span>
											<FormattedMessage {...messages.uploadInfo} />
										</span>
									</div>
								</div>
								<Loader
									show={profilePhotoLoading}
									type={"page"}
								>
									<div className={cx(s.space4, s.spaceTop4)}>
										<div className={s.space2}>
											{
												loading ? <Loader type={"text"} /> : <Avatar
													isUser
													title={guestDisplayName}
													className={cx(s.profileImage, s.mediaPhoto, s.mediaRound)}
												/>
											}
										</div>
									</div>
								</Loader>
								<Col xs={12} sm={12} md={12} lg={12} className={cx(s.spaceTop2, s.fullWidth, s.button, s.btnlarge, s.noPadding)}>
									<DropZone
										guestPicture={guestPicture}
										defaultMessage={formatMessage(messages.dropzoneUpload)}
									/>

								</Col>
								<Col xs={12} sm={12} md={12} lg={12} className={cx(s.noPadding, s.spaceTop2)}>
									<div onClick={this.handleSkip} className={s.skip}>überspringen</div>
									{
										guestPicture && <Button
											className={cx(s.button, s.btnPrimary)}
											onClick={this.handleClick}
										>
											<FormattedMessage {...messages.continue} />
										</Button>
									}

								</Col>
							</div>
						</div>
					</div>
				</Row>
			</Grid>
		);
	}
}
const mapState = (state) => ({
	profilePhotoLoading: state.account.profilePhotoLoading
});

const mapDispatch = {doUploadProfilePicture};

export default compose(
	injectIntl,
	withStyles(s),
	connect(mapState, mapDispatch),
	graphql(gql`
		query {
			userAccount {
				picture
			}
		}
	  `, {
			name: 'profilePictureData',
			options: {
				ssr: false
			}
		}),
)(AvatarUpload);